import React, { useState, useEffect } from 'react'

import { HealthModeContext } from './contexts'

export { HealthModeContext } from './contexts'

const HEALTH_KEY = 'keee-health'

export const HealthModeProvider: React.FC = ({ children }) => {
  const [healthMode, setHealthMode] = useState(localStorage.getItem(HEALTH_KEY) === 'true')
  useEffect(() => {
    localStorage.setItem(HEALTH_KEY, healthMode.toString())
  }, [healthMode])
  return <HealthModeContext.Provider value={{ healthMode, setHealthMode }}>{children}</HealthModeContext.Provider>
}
